import { useScrollReveal } from '@/hooks/useScrollReveal';

const requests = [
  '«Нужно маркетинговое агентство»',
  '«Ищем подрядчика по разработке»',
  '«Требуется SEO-продвижение»',
  '«Нужен интегратор CRM»',
  '«Ищем поставщика услуг»',
];

export default function TLProblem() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 150 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 250 });

  return (
    <section className="bg-background-50 py-20 md:py-28 border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <span
              ref={labelRef}
              className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
            >
              Проблема
            </span>
            <h2
              ref={titleRef}
              className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
            >
              Пока конкуренты ищут клиентов вручную — <span className="text-primary-500">AIGAM уже ведёт с ними переговоры</span>
            </h2>
            <p
              ref={descRef}
              className={`mt-5 text-[16px] md:text-[17px] leading-relaxed text-foreground-500 max-w-[520px] reveal-fade-up ${descRevealed ? 'revealed' : ''}`}
            >
              Каждый день в Telegram появляются тысячи сообщений от людей, которые ищут подрядчиков и сервисы. Большинство компаний отвечают слишком поздно. AIGAM находит запрос за секунды и начинает общение автоматически.
            </p>

            <div className="mt-8 flex items-center gap-6 pt-6 border-t border-background-200">
              <div>
                <div className="font-display text-[36px] font-extrabold text-foreground-950 leading-none">~3ч</div>
                <div className="mt-1 text-[13px] text-foreground-500">средняя реакция вручную</div>
              </div>
              <div className="w-px h-12 bg-background-200"></div>
              <div>
                <div className="font-display text-[36px] font-extrabold text-primary-500 leading-none">30с</div>
                <div className="mt-1 text-[13px] text-foreground-500">реакция AIGAM</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="rounded-2xl border border-background-200 bg-background-100 p-6 md:p-8">
              <div className="flex items-center gap-2 text-[12px] font-semibold uppercase tracking-wider text-foreground-500">
                <i className="ri-telegram-fill text-primary-500 text-base"></i>
                Типичные запросы
              </div>
              <div className="mt-5 space-y-3">
                {requests.map((req, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between rounded-lg bg-background-50 border border-background-200 px-4 py-3.5"
                  >
                    <div className="flex items-center gap-3 min-w-0">
                      <span className="w-8 h-8 rounded-full bg-primary-50 text-primary-500 flex items-center justify-center shrink-0">
                        <i className="ri-chat-1-line"></i>
                      </span>
                      <span className="text-[14px] md:text-[15px] text-foreground-800 truncate">{req}</span>
                    </div>
                    <span className="ml-3 text-[12px] font-semibold text-primary-600 whitespace-nowrap">→ найдено</span>
                  </div>
                ))}
              </div>
              <div className="mt-5 text-[13px] text-foreground-500 flex items-center gap-2">
                <i className="ri-information-line"></i>
                Это упрощённые формулировки запросов из открытых Telegram-чатов.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}